import themable from '_uikit/_themable'

export const Default = themable('OpportunityDefaultTile')

export default { Default }
